import { createJSONSchema } from '@carboncopyco/editor-utils';
import { JSONTree, type KeyPath } from 'react-json-tree';
import type { JsonFormValue } from '../JsonForm/types';
import { JsonTreeLabel } from './JsonTreeLabel';

const jsonTreeTheme = {
  tree: { backgroundColor: 'none' },
  label: { color: '#a31515' },
  arrowSign: { color: '#000000' },
  value: ({ style }) => ({
    style: {
      ...style,
      color: '#0451a5',
    },
  }),
  valueText: ({ style }) => ({
    style: {
      ...style,
      color: '#0451a5',
    },
  }),
  nestedNodeItemString: ({ style }) => ({
    style: {
      ...style,
      color: '#657B83',
    },
  }),
};

const transformDotIncludedKeys = (keys) => {
  return keys.map((key) => {
    if (typeof key === 'string' && key.includes('.')) {
      return `['${key}']`;
    }
    return key;
  });
};

const keyPathToJsonPath = (keyPath: KeyPath) => {
  let path = [...keyPath];
  path.pop(); // removes the "root"
  path.reverse();
  path = transformDotIncludedKeys(path);
  return path.join('.');
};

export interface JsonTreeProps {
  value: JsonFormValue;
  onAddField: (jsonPath: string) => void;
  onRemoveField: (jsonPath: string) => void;
}

export const JsonTree = ({
  value,
  onAddField,
  onRemoveField,
}: JsonTreeProps) => {
  const getFormField = (jsonPath: string) =>
    value.fields.find((field) => field.jsonPath === jsonPath);

  return (
    <div
      className="text-xs"
      style={{
        fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      }}
    >
      <JSONTree
        theme={jsonTreeTheme}
        data={value.json}
        labelRenderer={(keyPath) => {
          const [text] = keyPath;
          const jsonPath = keyPathToJsonPath(keyPath);
          const formField = getFormField(jsonPath);

          if (text === 'root') {
            return null;
          }

          const jsonSchema = createJSONSchema(value.json, jsonPath);

          return (
            <JsonTreeLabel
              text={String(text)}
              jsonSchema={jsonSchema}
              onAddToForm={() => onAddField(jsonPath)}
              onRemoveFromForm={() => onRemoveField(jsonPath)}
              hasFormField={!!formField}
            />
          );
        }}
      />
    </div>
  );
};
